<template>
	<div id="map" ref="map">
		
	</div>
</template>
<script>
import init from '../utils/gmaps'
import InfoContent from '../utils/infocontent'
import MarkerClusterer from '@google/markerclusterer'
import { mapGetters, mapActions } from 'vuex'
import eventbus from '../utils/eventbus'
import calculate from '../utils/distance'
export default {
	props: ['dealers'],
	data () {
		return {
			center: {
				lat: parseFloat( this.getDealersMapSettings().map_center.lat ),
				lng: parseFloat( this.getDealersMapSettings().map_center.long )
			},
			markers : [],
			markerClusterer: null,
			map: null,
			google: null,
			geocoder: null,
			searchLatLng: {
				lat: 0,
				lng: 0
			},
			autoComplete: null,
			infoWindow: null,
		}
	},
/*  eslint-disable no-unused-vars */
	async mounted () {
		try {
			// const dealer = this.dealers.dealers[0]
			// console.log( InfoContent( dealer ) )
			this.google = await init()
			this.map = new this.google.maps.Map( this.$refs.map, { zoom: 8, center: this.center } )
			this.geocoder = new this.google.maps.Geocoder()
			this.markers = this.searchList.map( ( dealer ) => {
				
				const marker = new this.google.maps.Marker( 
					{ position: 
						{ 
							lat: parseFloat( dealer.latlong.dealer_lat ), 
							lng: parseFloat( dealer.latlong.dealer_long ) 
						},
						map: this.map,
						icon: this.isPro( dealer, this.getActiveFilter() ) ? require( './../assets/hh-marker-pro.png' ) : require( './../assets/hh-marker_transp.png' )
					} 
				)
				marker.addListener( 'click', () => {
					this.createInfowindow( dealer )
					this.infoWindow.open( this.map, marker )
				} )
				marker.addListener( 'open-marker', ( event ) => {
					if ( dealer.street_address === event.data.street_address ) {
						this.createInfowindow( dealer )
						this.infoWindow.open( this.map, marker )	
					}
				} )
				return marker
			} )
			this.markerClusterer = new MarkerClusterer( this.map, this.markers, {
				imagePath: this.getDealersMapSettings().markercluster_path,
			} )			
			const input = document.getElementById( 'location-input' )
			const options = {
				bouds: this.map,
				types: [ '(regions)' ],
				// componentRestrictions: { country: 'BE' },
				language: 'nl'
			}
			this.autoComplete = new this.google.maps.places.Autocomplete( input, options )
		} catch ( error ) {
			console.log( error )
		}
		this.$watch( 'filterChanges', ( newValue, oldValue ) => {
			this.repaintMap()
		} ),
		this.$watch( 'subFilterChanges', ( newValue, oldValue ) => {
			this.repaintMap()
		} ),
		this.$watch( 'productGroepChanges', ( newValue, oldValue ) => {
			this.repaintMap()
		} )
		// this.$watch( 'searchChanges', ( newValue, oldValue ) => {
		// 	console.log( 'searchChanges' )
		// 	No go: the repaint map is called with different timings, depending on the type of search change.
		// } )
	},
	created () {
		eventbus.$on( 'search-launched', ( data ) => {
			if ( data === 'geocoded' ) {
				this.geocoder.geocode( { 'location': this.getSearchLatLng() }, ( results, status ) => {
					if ( status == 'OK' && results[4] ) {
						this.setSearch( results[4].formatted_address )
						eventbus.$emit( 'address-ready' )	
					} else {
						alert('Geocode was not successful for the following reason: ' + status)
					}
				} )
				this.map.setZoom( 10 )
				this.map.setCenter( this.getSearchLatLng() )
				setTimeout(() => {
					this.repaintMap()
				}, 750 )
			} else if ( this.getSearch() !== '' ) {
				this.geocoder.geocode( { 'address': this.getSearch() }, ( results, status ) => {
					if ( status == 'OK' ) {
						this.map.setCenter( results[0].geometry.location)
						this.searchLatLng.lat = results[0].geometry.location.lat()
						this.searchLatLng.lng = results[0].geometry.location.lng()
						this.setSearchCoords( this.searchLatLng )
						this.map.setZoom( 10 )
						this.map.setCenter( this.getSearchLatLng() )
						setTimeout(() => {
							this.repaintMap()
						}, 750 )
					} else {
						alert('Geocode was not successful for the following reason: ' + status)
					}
				} )
			}
			
		} ),
		eventbus.$on( 'clear-search', ( ) => {
			// console.log( 'clear-search' )
			// Only needed on programattical zoom out, only happens on clear location: First zoom, then wait & repaint; or else: clusters would be calculated on an inbetween zoom.
			this.map.setZoom( 8 )
			this.map.setCenter( this.center )
			setTimeout(() => {
				this.repaintMap()
			}, 1000 )
		} ),
		eventbus.$on( 'open-marker', ( data ) => {
			const markerDealer = this.dealers.find( ( dealer ) => {
				return dealer.latlong.dealer_lat === data.lat &&
					dealer.latlong.dealer_long === data.lng
			} )
			const latLng = {
				lat: parseFloat( data.lat ),
				lng: parseFloat( data.lng )
			}
			const correspondingMarker = this.markers.find( ( marker ) => {
				return marker.position.lat() === latLng.lat &&
					marker.position.lng() === latLng.lng
			} )
			this.createInfowindow( markerDealer )
			this.map.setZoom( 13 )
			this.map.setCenter( latLng )
			this.infoWindow.open( this.map, correspondingMarker )	
		} )
	},
	methods: {
		...mapGetters([
			'getActiveFilter',
			'getSubFilter',
			'getProductGroepen',
			'getSearch',
			'getSearchLatLng',
			'getDealersMapSettings',
			'getMicroCopy',
			'getReferrerProduct',
			'getReferrerProductID'
		]),
		...mapActions([
			'setSearchCoords',
			'setSearch'
		]),
		createInfowindow ( dealer ) {
			if ( this.infoWindow ) {
				this.infoWindow.close()
			}
			this.infoWindow = new this.google.maps.InfoWindow( { 
				content: InfoContent( dealer, this.getActiveFilter(), this.getMicroCopy(), this.getDealersMapSettings(), this.getReferrerProduct(), this.getReferrerProductID() )
			} )
		},
		repaintMap () {
			// console.log( 'repaint map' )
			if ( this.markerClusterer ) {
				this.markerClusterer.removeMarkers( this.markers )
			}
			this.markers.map( ( marker ) => {
				marker.setMap( null )
			} )
			this.markers = []
			this.markers = this.searchList.map( ( dealer ) => {
				
				const marker = new this.google.maps.Marker( 
					{ position: 
						{ 
							lat: parseFloat( dealer.latlong.dealer_lat ), 
							lng: parseFloat( dealer.latlong.dealer_long ) 
						},
						map: this.map,
						icon: this.isPro( dealer, this.getActiveFilter() ) ? require( './../assets/hh-marker-pro.png' ) : require( './../assets/hh-marker_transp.png' )
					} 
				)
				marker.addListener( 'click', () => {
					this.createInfowindow( dealer )
					this.infoWindow.open( this.map, marker )
				} )
				return marker	
			} )

			this.markerClusterer = new MarkerClusterer( this.map, this.markers, {
				imagePath: this.getDealersMapSettings().markercluster_path, // will be overwritten by styles
				// styles:[{
				// 	textColor: "#fff",
				// 	url: this.getDealersMapSettings().markercluster_path,
				// 	width: 53,
				// 	height: 52,
				// 	textSize: 12,
				// }],
				// imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m3' // https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m2.png OR https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m1.png
			} )
			
			// if ( this.getSearchLatLng() ) { 
			// 	this.map.setZoom( 10 )
			// 	this.map.setCenter( this.getSearchLatLng() )
			// } else {
				// No, only change zoom on a location search.
				// this.map.setZoom( 8 )
				// this.map.setCenter( this.center )
			// }
		},
		isPro ( dealer, currentBrand = '' ) {
			if ( '' !== currentBrand ) {
				return dealer.brands.some( ( brand ) => {
					return brand.slug === currentBrand && brand.pro === true
				} )
			} else {
				return false
			}
		}
	},
	computed: {
		filteredList () {
			const nrGroepen = this.getProductGroepen().length
			return this.dealers.filter( ( dealer ) => {
				return dealer.brands.find( ( brand ) => {
					if ( this.getActiveFilter() === '' ) return true
					return brand.slug === this.getActiveFilter() &&
						( this.getSubFilter() === true ? brand.pro === true : true ) &&
						( nrGroepen > 0 ?  brand.productgroepen && brand.productgroepen.filter( ( groep ) => {
							return this.getProductGroepen().indexOf( groep.slug ) !== -1
						} ).length > 0 : true )
				} )
			} )
		},
		searchList () {
			if ( '' === this.getActiveFilter() ) return []
			if ( ! this.getSearchLatLng() ) return this.filteredList
			let filteredDealers = this.filteredList.length === 0 ? this.dealers : this.filteredList
			return filteredDealers.filter( ( dealer ) => {
				const dealerLatLng = { 
					lat: parseFloat( dealer.latlong.dealer_lat ), 
					lng: parseFloat( dealer.latlong.dealer_long )
				}
				return calculate( this.getSearchLatLng(), dealerLatLng ) < 30.0
			} )
		},
		filterChanges () {
			return this.getActiveFilter()
		},
		subFilterChanges () {
			return this.getSubFilter()
		},
		productGroepChanges () {
			return this.getProductGroepen()
		},
		searchChanges () {
			return this.getSearch()
		}
	}
}
</script>
<style scoped>
#map {
	width: 100%;
	height: 100%;
	min-height: 580px;
}
</style>